import IconBtn from '@mui/material/IconButton';

const IconButton = ({children, color, ...props}) => {
    return (
        <IconBtn 
            color={color || "primary"} 
            aria-label="upload picture" 
            component="label"
            {...props}
        >
            {children}
        </IconBtn>
    );
};

export default IconButton;